<template>
  <table-view ref="table" class="h-full"
    v-model="selected"
    :value-key="PayloadSingleId"
    :get-params-path="getParamsPathAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-multiple="getParamsMultipleAux"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :breadcrumb-name="breadcrumbName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :lista-acciones="listaAccionesFinal"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction"
    @selectionChange="onSelectionChange" />
</template>

<script>
import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/ClientsFilter.vue'
import { getClientsPag } from '@/services/clients/getClientsPag'
import { getClientsExcel } from '@/services/clients/getClientsExcel'
import { activateClients } from '@/services/clients/activateClients'

export default {
  name: 'clients-list-view',
  components: {
    TableView
  },
  data () {
    return {
      idVista: 8,
      FilterPanel: CustomFilter,
      vuexnamespace: 'clients',
      headerTitle: i18n.t('clients.header'),
      headerIcon: 'config',
      routeName: 'configurations/clients/details',
      excelName: `${i18n.t('clients.header').toLowerCase()}.xlsx`,
      breadcrumbName: 'Nombre',
      PayloadSingleId: 'idCliente',
      listaAcciones: [
        // { IdAccion: 700, Descripcion: i18n.t('app.edit_fields'), icon: 'editpencil' },
        { IdAccion: 701, Descripcion: i18n.t('personalization.edit_personalization'), icon: 'editpenciladd' },
        { IdAccion: 800, Descripcion: i18n.t('app.enable'), icon: 'check' },
        { IdAccion: 801, Descripcion: i18n.t('app.disable'), icon: 'cross' }
      ],
      listaAccionesFinal: [],
      processMessage: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('clients.header').toLowerCase() }),
      selected: []
    }
  },
  mounted () {
  },
  computed: { 
    footerAcciones () {
      const acciones = [
        { text: i18n.t('clients.new_client'), icon: 'plus', handler: this.goToNewClient }
      ]
      if (this.role === 3 || (this.hasPermiteWizard && [7, 8].includes(this.role))) {
        acciones.push(        
          { text: i18n.t('clients.new_client_wizard'), icon: 'plus', handler: this.goToNewClientWizard }
        )
      }
      return acciones
    },
    hasPermiteWizard () {
      return this.$store.getters['auth/hasPermiteWizard']
    },
    hasAnyPersonalizationModule () {
      return this.$store.getters['auth/hasAnyPersonalizationModule']
    },
    hasModuleXslt () {
      return this.$store.getters['auth/hasCustomMailsModule']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    disableTipoLibre () {
      return (this.role === 8 || this.role === 7) &&
       this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    }
  },
  methods: {
    getParamsPathAux (data) {
      return { id: data.idCliente }
    },
    getParamsAux (data) {
      return {
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        Nombre: !this.isClientFilterActive && data.name ? data.name.value : null,
        EmailsContacto: data.EmailsContacto ? data.EmailsContacto.value : null,
        CodigoExterno: data.codigoExterno ? data.codigoExterno.value : null,
        NumeroSerie: data.ns ? data.ns.value : null,
        idPartner: data.partner ? data.partner.value : null,
        idGrupoCliente: data.grupoCliente ? data.grupoCliente.value : null,
        idTipoServicio: data.tipoServicio ? data.tipoServicio.value : null,
        Activo: data.activo ? data.activo.value : null,
        PagarAlContabilizar: data.PagarAlContabilizar ? data.PagarAlContabilizar.value : null,
        PendienteFacturacion: data.PendienteFacturacion ? data.PendienteFacturacion.value : null,
        idCliente: this.isClientFilterActive ? this.actualFilterNav?.idCliente : null,
        idFaseConfiguracion: data.FaseConfiguracion ? data.FaseConfiguracion.value : null,
        idPaqueteContratacion: data.PaqueteContratacion ? data.PaqueteContratacion.value : null,
        certificadoSAML2Caducado: data.certificadoSAML2Caducado ? data.certificadoSAML2Caducado.value : null,
        certificadoSAML2PorCaducar: data.certificadoSAML2PorCaducar ? data.certificadoSAML2PorCaducar.value : null,
      }
    },
    getParamsMultipleAux (data) {
      return {
        modulosContratados: data.ModulosContratados ? data.ModulosContratados.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getClientsPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      try {
        return await getClientsExcel(objOrder, params)
      } catch (error) {}
    },
    goToNewClient: function () {
      this.$router.push({ name: 'configurations/clients/details', params: { id: -1 } })
    },
    goToNewClientWizard: function () {
      this.$router.push({ name: 'configurations/clients/details', params: { id: -1, wizard: 'wizard' } })
    },
    executeAction: async function ({ action, selected = [], event }) {
      if (selected.length) {
        if (action.IdAccion === 700) {
          const data = { clients: selected.map(x => x.idCliente) }
          if (this.role === 3) {
            const idDistribuidor = selected.map(x => x.idDistribuidor)[0]
            this.$router.push({ name: 'configurations/distributors/template/clients', params: { data: data, id: idDistribuidor } })
          } else {
            this.$router.push({ name: 'configurations/template/clients', params: { data: data } })
          } 
        } else if (action.IdAccion === 701) {
          const data = { clients: selected.map(x => x.idCliente) }
          if (this.role === 3) {
            const idDistribuidor = selected.map(x => x.idDistribuidor)[0]
            this.$router.push({ name: 'configurations/distributors/template/clientspersonalization', params: { data: data, id: idDistribuidor } })
          } else {
            this.$router.push({ name: 'configurations/template/clientspersonalization', params: { data: data } })
          } 
        } else if (action.IdAccion === 800) {
          this.activateHandler(true)
        } else if (action.IdAccion === 801) {
          this.activateHandler(false)
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
        }
      }
    },
    onSelectionChange: function (selected = []) {
      let accionesFinal = []
      if (selected.length) {
        accionesFinal = this.listaAcciones
        if (this.disableTipoLibre) {
          accionesFinal = accionesFinal.filter(x => x.IdAccion !== 800).filter(x => x.IdAccion !== 801)
        } 
        const Distribuidor = selected.map(x => x.Distribuidor)[0]
        if (!this.hasAnyPersonalizationModule ||
          !this.hasModuleXslt ||
          !Distribuidor ||
          selected.filter(x => x.Distribuidor === Distribuidor).length !== selected.length
        ) {
          accionesFinal = accionesFinal.filter(x => x.IdAccion !== 700).filter(x => x.IdAccion !== 701)
        }
      }
      this.listaAccionesFinal = accionesFinal
    },
    activateHandler: async function (activateParam, selected = []) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idClientes: [],
          valor: activateParam,
        }
        for (const element of selected) {
          payload.idClientes.push(element.idCliente)
        }
        const response = await activateClients(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
  },
}
</script>

<style scoped>

</style>
